export const STORE_KEY = {
  ACCESS_TOKEN: `95f3a8d8490c5b898c73ccdc0e2258ac`,
  USER_INFO: `15beb5099d687720cc55bcb7f943e826`,
};
